import type { JourneyTaskDef } from '../../../entities/journey'
import styles from './JourneyPage.module.css'

export default function TaskDetails({ task }: { task: JourneyTaskDef }) {
  return <div className={styles.taskDetails}>
    {task.why && <p>{task.why}</p>}
    <h3>Что сделать</h3>
    <ol>{task.steps.map((step, index) => <li key={index}>{step}</li>)}</ol>
  </div>
}
